import React from 'react';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';
import { Subscription } from '@/api/bol-notifications';

export interface SubscriptionDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  subscription: Subscription | null;
}

export const SubscriptionDeleteDialog: React.FC<SubscriptionDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  subscription
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="subscription"
      itemId={subscription?.name || ''}
      customMessage={`Are you sure you want to delete subscription "${subscription?.name}"? This will also delete all associated consumers and notifications. This action cannot be undone.`}
    />
  );
};